import customFetch from '../../utils/customFetch'
import { API_ENDPOINT } from '../../config'
import { User } from '../../@types/types'
import NotLoggedInError from '../../services/domain/errors/NotLoggedInError'
import { userToApp } from './converters/user'
import { getDefaultLogger } from '../../services/logger/logger'

export const getUser: () => Promise<User> = async () => {
  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
  }

  try {
    const response = await customFetch(`${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/user`, options)
    if (response.status === 200) {
      const result = await response.text()
      return userToApp(result)
    } else if (response.status === 204) {
      return Promise.reject(new NotLoggedInError())
    }
    getDefaultLogger().warn(`Cannot load user, failed with ${response.status}`)
    return Promise.reject(new NotLoggedInError())
  } catch (error) {
    getDefaultLogger().warn(`Cannot load user`, error)
    throw new NotLoggedInError()
  }
}
